<template>
  <div>
    <SellHeader :img_header="header_image" header="คำสั่งซื้อ" link_back="sell/orderpartnermain"/>
    <Order_partner_detail/>
  </div>
</template>

<script>
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/boxes_sell.png";
import Order_partner_detail from "@/components/admin/sell/Order_partner_detail";
export default {
  name: "OrderPartnerDetail",
  components: {
    Order_partner_detail,
    SellHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
